
import React from 'react';
import KanbanFeature from '../features/kanban/Kanban';

const KanbanPage: React.FC = () => {
  return <KanbanFeature />;
};

export default KanbanPage;
